<template lang="pug">
div(class="container")
  div(class="card")
    header(class="card-header")
      p(class="card-header-title") Selectors
    div(class="card-content")
      b-error(v-if="error" :error="error" class="error")
      div(class="content")
        nx-table(
          ref="nxTable"
          url-add="selector/add"
          url-edit="selector/edit"
          url-fetch="selector/list"
          url-delete="selector/delete"
          :selected-columns="selectedColumns"
          :checkable="true"
          @fillEdit="fill($event)"
        )
          template(#column-organization="row") {{ row.organization.name }}
          template(#column-merchant="row") {{ row.merchant.displayname }}
          template(#form="props")
            div(class="modal-card" style="width: auto")
              header(class="modal-card-head")
                p(class="modal-card-title") {{ props.modeAdd ? 'Add selector' : 'Edit selector' }}
              section(class="modal-card-body")
                b-field(label="Merchant")
                  b-select(
                    v-model="merchant"
                    placeholder="Merchant"
                    required
                  )
                    option(
                      v-for="merchant in merchants"
                      :key="merchant._id"
                      :value="merchant"
                    ) {{ merchant.displayname }}

                b-field(label="Organization")
                  b-select(
                    v-model="formData.organizationId"
                    placeholder="Organization"
                    required
                  )
                    template(v-if="merchant")
                      option(
                        v-for="organization in merchant.organizations"
                        :key="organization._id"
                        :value="organization._id"
                      ) {{ organization.name }}

                b-field(label="Name")
                  b-input(
                    v-model="formData.name"
                    type="string"
                    placeholder="Name"
                    required
                  )

                b-field(label="regex")
                  b-input(
                    v-model="formData.regex"
                    type="string"
                    placeholder="regex"
                    required
                  )

                b-field(label="draftMode")
                  b-checkbox(
                    v-model="formData.draftMode"
                  )
              footer(class="modal-card-foot")
                b-button(
                  label="Close"
                  icon-left="close"
                  @click="$refs.nxTable.close()"
                )
                b-button(
                  label="Save"
                  icon-left="plus"
                  type="is-primary"
                  @click="save()"
                )
                b-message(v-if="props.error" title="error") {{ props.error }}

    footer(class="card-footer")
</template>

<script>
import nxTable from '@nx-t/vue-components/vue2/nxTableOld';
import bError from '@nx-t/vue-components/vue2/bError';

export default {
  components: {
    nxTable,
    bError,
  },
  data() {
    return {
      selectedColumns: ['name', 'regex', 'draftMode', 'organization', 'merchant'],
      merchants: [],
      merchant: null,
      formData: {
        name: '',
        regex: 'default',
        draftMode: false,
        organizationId: null,
        merchantId: null,
      },
      error: null,
    };
  },
  created() {
    this.fetchMerchants();
  },
  methods: {
    save() {
      this.formData.merchantId = this.merchant._id;
      this.$refs.nxTable.save(this.formData);
    },
    async fetchMerchants() {
      this.merchants = null;
      this.error = null;

      try {
        const response = await fetch('merchant/list');
        if (!response.ok) {
          const errorData = await response.json();
          throw errorData || { message: 'Unknown Error', status: response.status };
        }

        const data = await response.json();
        this.columns = [];
        this.merchants = data.list;
      } catch (e) {
        this.error = e?.message || e?.toString() || 'Unknown Error';
      }
    },
    fill(editData) {
      this.formData = editData;
      this.merchant = this.merchants.find((m) => m._id === editData.merchant._id);
      this.formData.organizationId = editData.organization._id;
    },
  },
};

</script>
